import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations as itPack } from "./it";
import { translations as enPack } from "./en";
import { translations as dePack } from "./de";

const packs = { it: itPack.it, en: enPack.en, de: dePack.de };
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("dyn_lang") : null;
    return ["it", "en", "de"].includes(saved) ? saved : "it";
  });

  const changeLang = useCallback((l) => {
    if (!packs[l]) return;
    setLang(l);
    localStorage.setItem("dyn_lang", l);
    document.documentElement.lang = l;
  }, []);

  const value = useMemo(() => ({ lang, t: packs[lang], changeLang }), [lang, changeLang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
